import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAlert } from 'react-alert';
import { Modal, Table } from 'react-bootstrap';
import MetaData from '../../layouts/MetaData';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import AddNewAdminForm from '../../components/Form/AddNewAdminForm';
import { Prod01 } from '../../constants/ActionType';
import { useSortableTable, SortableTh, nameFromString } from '../../components/SortableTable';

const EC_SORT_COLUMNS = {
    name: { type: 'name', value: (r) => nameFromString(r?.name) },
    email: { type: 'string', value: (r) => r?.email },
    status: { type: 'boolean', value: (r) => r?.block },
};

// Super Admin (any organization) and Org Manager (own organizations) manage Enrollment Coordinators.
const EnrollmentCoordinators = () => {
    const alert = useAlert();
    const [rows, setRows] = useState([]);
    const tableSort = useSortableTable(rows, { id: 'admin.enrollmentCoordinators', columns: EC_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const [orgs, setOrgs] = useState({});
    const [show, setShow] = useState(false);

    const load = useCallback(async () => {
        try {
            const [{ data }, orgRes] = await Promise.all([
                axios.get(`${Prod01}/enrollment/coordinators`),
                axios.get(`${Prod01}/general/organizations`).catch(() => ({ data: [] })),
            ]);
            setRows(data || []);
            const m = {};
            (orgRes.data || []).forEach((o) => { m[String(o._id)] = o.name; });
            setOrgs(m);
        } catch (err) {
            alert.error(err?.response?.data?.message || err.message);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        load();
    }, [load]);

    return (
        <>
            <MetaData title="Enrollment Coordinators" />
            <Sidebar />
            <section className="home-section">
                <TopBar />
                <div className="shadow-lg p-3 mb-2 mr-4 ml-4 rounded">
                    <div className="home-content">
                        <div className="row-display">
                            <h5 style={{ color: '#004aad' }}>
                                <i className="fas fa-id-badge"></i> <strong>&nbsp;Enrollment Coordinators</strong>
                            </h5>
                            <button className="add-staff-btn" type="button" onClick={() => setShow(true)}>
                                <small>Add Enrollment Coordinator</small>
                            </button>
                        </div>
                        <hr />
                        <Table className="table table-sm table-striped">
                            <thead><tr>
                                <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                <SortableTh sortKey="email" sort={tableSort}>Email</SortableTh>
                                <th>Organizations</th>
                                <SortableTh sortKey="status" sort={tableSort}>Status</SortableTh>
                            </tr></thead>
                            <tbody>
                                {tableSort.rows.map((r) => (
                                    <tr key={r._id}>
                                        <td>{r.name}</td>
                                        <td>{r.email}</td>
                                        <td>{(r.organizationIds || []).map((id) => orgs[String(id)] || String(id)).join(', ')}</td>
                                        <td>{r.block ? 'Blocked' : 'Active'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <Modal show={show} onHide={() => setShow(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Enrollment Coordinator</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AddNewAdminForm roles={['enrollment']} onHandleClose={setShow} onCreated={load} />
                    </Modal.Body>
                </Modal>
            </section>
        </>
    );
};

export default EnrollmentCoordinators;
